export class AssertionError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
        this.name = 'AssertionError';
    }
}
export const assert = (value, message) => {
    if (!value)
        throw new AssertionError(message);
};
//# sourceMappingURL=assert.js.map